import { HTTP_API_V2 } from '../../http-common'

export default {
  actions: {
    loadRemoteAccessUrl ({ commit }, deviceId) {
      return new Promise((resolve, reject) => {
        HTTP_API_V2
          .get(`devices/${deviceId}/remote-access-url`)
          .then(result => {
            const remoteAccessUrl = result.data.remoteAccessUrl
            resolve(remoteAccessUrl)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
      })
    },
    loadDevicesByIdentifierValue ({ commit }, identifierValue) {
      return new Promise((resolve, reject) => {
        HTTP_API_V2
          .get(`devices/identifier/${identifierValue}`)
          .then(result => {
            const devices = result.data
            resolve(devices)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
      })
    },
    createDeviceLoginToken ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get(`devices/device-login-token/${payload.mac}`, {
          withCredentials: true
        })
          .then((response) => {
            const loginToken = response.data.loginToken || response.data.tokenV1 || response.data.productLoginToken || null
            const authMethod = response.data.authMethod ||
              (response.data.tokenV1 ? 'legacy-jwt' : (response.data.productLoginToken ? 'firebase-custom-token' : 'legacy-jwt'))

            resolve({
              loginToken,
              firmwareVersion: response.data.firmwareVersion || null,
              authMethod
            })
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/device_remote_access_url/index.js